<template>
    <div v-if="isMounted">
        <div class="card card-body">
            <el-tabs v-model="$parentInfo.courseFeedback.activeTab" type="card">
                <el-tab-pane label="老师评价" name="teacherEvaluation">
                    <el-table
                            :data="orderTeacherFeedback"
                            v-loading="$parentInfo.courseFeedback.teacherFeedback.loading"
                            style="width: 100%">
                        <el-table-column
                                prop="date"
                                label="教师反馈时间"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="class_name"
                                label="课程"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="teacher_name"
                                label="老师"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                prop="serious_degree"
                                label="上课投入程度"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="note_degree"
                                label="笔记记录"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="review_degree"
                                label="回家复习消化"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="content"
                                label="反馈内容">
                        </el-table-column>
                    </el-table>
                    <!--分页-->
                    <div class="text-center m-t-10">
                        <el-pagination
                                @size-change="handleFeedBackSizeChange"
                                @current-change="handleFeedBackCurrentChange"
                                :current-page="$parentInfo.courseFeedback.teacherFeedback.currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="$parentInfo.courseFeedback.teacherFeedback.total">
                        </el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="课堂描述" name="classDescription">
                    <div>
                        <table class="table table-striped" v-loading="$parentInfo.courseFeedback.teacherReturnVisit.loading">
                            <thead>
                            <tr>
                                <th>课程名称</th>
                                <th>上课日期</th>
                                <th>上课时间</th>
                                <th>老师</th>
                                <th>回访内容</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in orderTeacherReturnVisits">
                                <td>{{item.className}}</td>
                                <td>{{item.date}}</td>
                                <td>{{item.start_time}}-{{item.end_time}}</td>
                                <td>{{item.teacherName}}</td>
                                <td>{{item.content}}</td>
                            </tr>
                            </tbody>
                        </table>
                        <!--分页-->
                        <div class="text-center m-t-10">
                            <el-pagination
                                    @size-change="handleReturnVisitSizeChange"
                                    @current-change="handleReturnVisitCurrentChange"
                                    :current-page="$parentInfo.courseFeedback.teacherReturnVisit.currentPage"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="10"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="$parentInfo.courseFeedback.teacherReturnVisit.total">
                            </el-pagination>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>

</template>

<script>
    export default {
        name: "CourseFeedback",
        data() {
            return {
                isMounted:false,
            };
        },
        computed:{
            orderTeacherReturnVisits: function () {
                return this._.orderBy(this.$parentInfo.courseFeedback.teacherReturnVisit.teacherReturnVisits, 'created_at','desc');
            },
            orderTeacherFeedback: function () {
                return this._.orderBy(this.$parentInfo.courseFeedback.teacherFeedback.teacherFeedback, 'created_at','desc');
            }
        },
        mounted() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleIndex();
            this.handleShowTeacherFeedBack();
            this.isMounted=true;
        },
        methods: {
            handleShowTeacherFeedBack(currentPage = 1, currentPageSize = 10) {
                this.$wApi.send(this.$parentInfo.path, 'teacher_feedBack', {'currentPage':currentPage,'currentPageSize':currentPageSize,'student_id':this.$parentInfo.student_id})
            },
            handleFeedBackSizeChange(val) {
                this.currentPageSize = val;
                this.handleShowTeacherFeedBack(this.currentPage, this.currentPageSize)
            },
            handleFeedBackCurrentChange(val) {
                this.currentPage = val;
                this.handleShowTeacherFeedBack(this.currentPage, this.currentPageSize)
            },
            handleIndex(currentPage = 1, currentPageSize = 10){
                this.$wApi.send(this.$parentInfo.path, 'teacher_returnVisit', {'currentPage':currentPage,'currentPageSize':currentPageSize,'student_id':this.$parentInfo.student_id})
            },
            handleReturnVisitSizeChange(val) {
                this.currentPageSize = val;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
            handleReturnVisitCurrentChange(val) {
                this.currentPage = val;
                this.handleIndex(this.currentPage, this.currentPageSize)
            }
        }

    }
</script>

<style scoped>

</style>